import React, {useEffect, useState, useContext} from "react";
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from "react-router-dom";
import { FirebaseAuth } from "../../FirebaseAuth/firebase";
import UserMenu from '../../menus/UserMenu';
import AppMenu from '../../menus/AppMenu';
import PublicTemplate from "../../templates/PublicTemplate";
import Loader from "../../Loader";
import { AuthContext } from "../../FirebaseAuth";
import AccountMenu from "../../menus/AccountMenu";
import Layout from '../../Layout';

const AccountTemplate = ({ role, allowInactive, children }) => {
    const { t } = useTranslation();
    const { accountId } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { setUserData, authUser } = useContext(AuthContext);
    const [isActive, setIsActive] = useState(false);

    allowInactive = allowInactive || false;

    useEffect(() => {
        let account = {}
        setLoading(true);
        const accountRef = FirebaseAuth.firestore().doc('accounts/'+accountId);
        accountRef.get().then(doc => {
            if(doc.exists){
                if(doc.data().subscriptionStatus && (doc.data().subscriptionStatus==='active' || doc.data().subscriptionStatus==='past_due')){
                    setIsActive(true);
                }
                account.id = doc.id;
                account.owner = doc.data().owner;
                account.name = doc.data().name;
                account.planId = null;
                if(doc.data().plan){
                    account.planId = doc.data().plan.id;
                }
                account.price = doc.data().price;
                account.currency = doc.data().currency;
                account.paymentCycle = doc.data().paymentCycle;
                account.subscriptionStatus = doc.data().subscriptionStatus;
                account.domains = doc.data().domains;
                account.cap = doc.data().cap;
                account.subscriptionCurrentPeriodEnd = doc.data().subscriptionCurrentPeriodEnd;
                account.role = (doc.data().admins.indexOf(authUser.user.uid) === -1?('user'):('admin'));
                setUserData(userData => ({
                    ...userData,
                    currentAccount: account
                }));
                if(account.role !== role && role !== '*'){
                    setError(t('accountTemplate.permissionDenied'));
                }
                setLoading(false);
            }else{
                setError(t('accountTemplate.invalidAccount'));
                setLoading(false);
            }
        }).catch(err => {
            setError(err.message);
            setLoading(false);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[accountId, setUserData, role, authUser]);

    return (
        <>
            {loading ? (
                <PublicTemplate>
                    <Loader text={t('common.loading')}/>
                </PublicTemplate>
            ):(
                <>
                {error === null ? (
                    (isActive || (!isActive && allowInactive)) ? (
                        <Layout drawerMenu={isActive?(
                            <AccountMenu />
                        ):(
                            <AppMenu />
                        )} toolBarMenu={<UserMenu />} >
                            {children}
                        </Layout>
                    ):(
                        <Navigate to={'/account/'+accountId+'/billing/plan'} replace />
                    )
                ):(
                    <PublicTemplate>
                        {error}
                    </PublicTemplate>
                )}
                </>
            )}
        </>
		
    )
}

export default AccountTemplate;